<template>
  <RbInput
    v-model.trim="cep"
    :label="props.label"
    :placeholder="props.placeholder"
    :color="props.color"
    :primary="props.primary"
    :secondary="props.secondary"
    :disabled="props.disabled"
    :required="props.required"
    :max-length="9"
    pattern="\d{5}-?\d{3}"
    inputmode="numeric"
    @keyup="keyup"
    @focusout="handleSeachCep"
  />
</template>

<script setup lang="ts">
import { withDefaults, ref, watch, onBeforeMount } from 'vue';
import RbInput from './RbInput.vue';
import { formatCep } from '@/lib/Formatting';
import { getCep } from '@/api/Cep';
import { loaderStore } from '@/store/app';

const emits = defineEmits([
  'update:modelValue',
  'update:state',
  'update:city',
  'update:street',
  'update:neighborhood'
]);

const props = withDefaults(defineProps<{
  modelValue: any,
  state?: any,
  city?: any,
  street?: any,
  neighborhood?: any,
  seachCep?: boolean
  label: string,
  color?: string,
  placeholder?: string,
  primary?: boolean,
  secondary?: boolean,
  disabled?: boolean,
  required?: boolean
}>(), {
  seachCep: false,
  placeholder: '',
  color: 'rgba(0, 0, 0, 0.6)',
  state: undefined,
  city: undefined,
  street: undefined,
  neighborhood: undefined,
});

const cep = ref('');

async function handleSeachCep() {
  if (props.seachCep && cep.value.length === 9) {
    try {
      loaderStore().setOpen(true);
      await search();
    } catch (error) { }
    finally {
      loaderStore().setOpen(false);
    }
  }
}

async function search() {
  const response = await getCep(cep.value);
  emits('update:state', response?.state ?? '');
  emits('update:city', response?.city ?? '');
  emits('update:neighborhood', response?.neighborhood ?? '');
  emits('update:street', response?.street ?? '');
}

onBeforeMount(() => {
  cep.value = props.modelValue;
});

watch(() => props.modelValue, () => {
  cep.value = formatCep(props.modelValue);
});

watch(() => cep.value, () => {
  emits('update:modelValue', formatCep(cep.value));
});

function keyup(event) {
  event.composedPath()[0].value = formatCep(event.composedPath()[0].value);
}
</script>
